<div>
  <div class="modal-header red">
    <div class="container-fluid">
      <div class="row modal-header-row">
        <div class="modal-icon icon fill-white" aria-label="logo" [inlineSVG]="'assets/ico/budget.svg'">
        </div>
        <span class="modal-title" id="modal-basic-title">Error while bulk edit</span>
        <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
        [inlineSVG]="'assets/ico/close-24px.svg'"></div>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="fullwidth">
      <div class="container-fluid">
        <div class="row mt-2 mb-2" style="padding: 0px 15px 0px 15px;">
          <div>While bulk edit Budgets, <strong>{{successes.length}}</strong> updated successfully and <strong>{{errors.length}}</strong> had errors while updating.<br /><br /></div>
          <div style="display: block; width: 100%;margin-bottom: 10px;font-weight: 800;">Errors:</div>
          @for (error of errors; track error; let i = $index; let last = $last) {
            <div style="display: block; width: 100%;">
              <p [class.pb-2]="errors.length > 1 && !last">
                @if (error.message) {
                  <span class="error-details"><strong>{{i + 1}}.
                  {{error.message}}</strong></span>
                }
                @if (error.details) {
                  <span class="error-secondary-details">{{error.details}}</span>
                }
                @if (!error.message && !error.details) {
                  <span
                    class="error-details"><strong>{{'modals.error.unknownError' |
                  translate}}</strong></span>
                }
                @if (error.errorTraceId) {
                  <span
                    class="error-secondary-details"><strong>{{'modals.error.traceID' | translate}}:
                  </strong>{{error.errorTraceId}}</span>
                }
              </p>
            </div>
          }
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer p-0">
    <div class="container-fluid m-0 p-0">
      <span class="btn modal-btn save" (click)="close()">{{'buttons.close' | translate }}</span>
    </div>
  </div>
</div>